import { createSlice } from '@reduxjs/toolkit';
import { IChartData } from 'modules/inbound/entriesST12/domain/chartData';
import {
  getPackagesChartData,
  getT12EDetailUnloadedTrunkChartData,
  getTrunkChartData,
  getUnloadedTrunkChartData
} from './async';
import { DischargeDocksState } from './types';

export const GREEN = 'green700';

const emptyChartData: IChartData = {
  chartData: [],
  topValueOnChart: 0
};

export const initialState: DischargeDocksState = {
  workshopType: 'T12',
  trunkData: emptyChartData,
  filteredTrunkData: {
    T12E: emptyChartData
  },
  unloadedTrunkData: emptyChartData,
  t12EDetailUnloadedTrunkData: emptyChartData,
  packagesData: emptyChartData,
  packagesRequestStatus: '',
  trucksRequestStatus: '',
  unloadedTrunksRequestStatus: '',
  t12EDetailUnloadedTrunksRequestStatus: ''
};

const chartDateSlice = createSlice({
  name: 'chartDateSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //packages
    builder.addCase(getPackagesChartData.fulfilled, (state, action) => {
      state.packagesData = action.payload.chartData || emptyChartData;
      state.packagesRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getPackagesChartData.pending, (state, action) => {
      state.packagesRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getPackagesChartData.rejected, (state, action) => {
      state.packagesRequestStatus = action.meta.requestStatus;
    });
    //trunk
    builder.addCase(getTrunkChartData.fulfilled, (state, action) => {
      const trunkData = action.payload.chartData || emptyChartData;
      state.trunkData = trunkData;
      state.filteredTrunkData = {
        T12E: action.payload.filterdData || emptyChartData
      };
      state.trucksRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getTrunkChartData.pending, (state, action) => {
      state.trucksRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getTrunkChartData.rejected, (state, action) => {
      state.trucksRequestStatus = action.meta.requestStatus;
    });

    //unloaded trunk
    builder.addCase(getUnloadedTrunkChartData.fulfilled, (state, action) => {
      const trunkData = action.payload.chartData || emptyChartData;
      state.unloadedTrunkData = trunkData;
      state.unloadedTrunksRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getUnloadedTrunkChartData.pending, (state, action) => {
      state.unloadedTrunksRequestStatus = action.meta.requestStatus;
    });
    builder.addCase(getUnloadedTrunkChartData.rejected, (state, action) => {
      state.unloadedTrunksRequestStatus = action.meta.requestStatus;
    });

    // T12E detail unloaded trucks
    builder.addCase(
      getT12EDetailUnloadedTrunkChartData.fulfilled,
      (state, action) => {
        state.t12EDetailUnloadedTrunkData =
          action.payload.chartData || emptyChartData;
        state.t12EDetailUnloadedTrunksRequestStatus = action.meta.requestStatus;
      }
    );
    builder.addCase(
      getT12EDetailUnloadedTrunkChartData.pending,
      (state, action) => {
        state.t12EDetailUnloadedTrunksRequestStatus = action.meta.requestStatus;
      }
    );
    builder.addCase(
      getT12EDetailUnloadedTrunkChartData.rejected,
      (state, action) => {
        state.t12EDetailUnloadedTrunksRequestStatus = action.meta.requestStatus;
      }
    );
  }
});

//selectors
export const getPackagesData = (state) =>
  state.chartDateSliceState.packagesData;
export const getTrunkData = (state) => state.chartDateSliceState.trunkData;
export const getFilteredTrunkData = (state, trunkType = 'T12E') =>
  state.chartDateSliceState.filteredTrunkData[trunkType];
export const getUnloadedTrunkData = (state) =>
  state.chartDateSliceState.unloadedTrunkData;
export const getT12EDetailUnloadedTrunkData = (state) =>
  state.chartDateSliceState.t12EDetailUnloadedTrunkData;

export const getPackagesRequestStatusIsPending = (state) =>
  state.chartDateSliceState.packagesRequestStatus === 'pending';
export const getPackagesRequestStatusHasError = (state) =>
  state.chartDateSliceState.packagesRequestStatus === 'rejected';
export const getPackagesRequestStatusIsSucessfull = (state) =>
  state.chartDateSliceState.packagesRequestStatus === 'sucessfull';

export const getTrunkRequestStatusIsPending = (state) =>
  state.chartDateSliceState.trucksRequestStatus === 'pending';
export const getTrunkRequestStatusHasError = (state) =>
  state.chartDateSliceState.trucksRequestStatus === 'rejected';
export const getPackagesTrunkRequestStatusIsSucessfull = (state) =>
  state.chartDateSliceState.trucksRequestStatus === 'sucessfull';

export const getUnloadedTrunkRequestStatusIsPending = (state) =>
  state.chartDateSliceState.unloadedTrunksRequestStatus === 'pending';
export const getUnloadedTrunkRequestStatusHasError = (state) =>
  state.chartDateSliceState.unloadedTrunksRequestStatus === 'rejected';
export const getUnloadedTrunkRequestStatusIsSucessfull = (state) =>
  state.chartDateSliceState.unloadedTrunksRequestStatus === 'sucessfull';

export const getT12EDetailUnloadedTrunkRequestStatusIsPending = (state) =>
  state.chartDateSliceState.t12EDetailUnloadedTrunksRequestStatus === 'pending';
export const getT12EDetailUnloadedTrunkRequestStatusHasError = (state) =>
  state.chartDateSliceState.t12EDetailUnloadedTrunksRequestStatus ===
  'rejected';

/**export const {
  updateSelectedHourEntryType,
  updateSelectedDaysEntryType,
  updateSelectedHour
} = chartDateSlice.actions;*/
export default chartDateSlice.reducer;
